import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M42.2584 84.6987C43.2409 83.7588 49.7355 77.7959 53.3808 62.3327C56.5839 49.1941 57.5566 27.0203 51.3273 16.0849C42.8774 1.24841 30.2713 1.81437 28.8958 1.81437C27.5202 1.81437 14.924 1.24841 6.48392 16.0849C0.254587 27.0203 1.21748 49.2245 4.42057 62.3327C8.06582 77.7959 14.5506 83.7588 15.5528 84.6987C17.3214 86.3663 22.7843 87.8115 28.9253 87.8115C35.0662 87.8115 40.48 86.3663 42.2584 84.6987Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
  )
}
